import { Modal, IconButton, TextField, ButtonGroup, Button } from '@nike/eds';
import { useState } from 'react';

export default function NicknameNewItem({
  onCreateFn,
}: {
  onCreateFn: (data: NicknameItemPayload) => Promise<unknown>;
}) {
  const [visible, setVisible] = useState(false);
  const [productCode, setProductCode] = useState('');
  const [nickName, setNickName] = useState('');
  const [stErrMessage, setStErrMessage] = useState('');
  const [nickNameErrMessage, setNicknameErrMessage] = useState('');
  const [apiError, setApiError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetModal = () => {
    setProductCode('');
    setNickName('');
    setStErrMessage('');
    setNicknameErrMessage('');
    setApiError('');
    setIsSubmitting(false);
  };
  const onOpenModal = () => {
    setVisible(true);
    resetModal();
  };
  const onSubmitBtnClick = async () => {
    if (!productCode) {
      setStErrMessage('productCode should not be empty!');
      return;
    }
    if (!nickName) {
      setNicknameErrMessage('nickName should not be empty!');
      return;
    }

    const nicknames = nickName
      .split(/[,;]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0);

    if (nicknames.length === 0) {
      setNicknameErrMessage('nickName should not be empty!');
      return;
    }

    const payload = {
      productCode: productCode,
      nicknames: nicknames,
      isDelete: false,
      nickname: nicknames.join(','),
    };
    setApiError('');
    setIsSubmitting(true);
    try {
      await onCreateFn(payload);
      setVisible(false);
    } catch (err: unknown) {
      const status = (err as { status?: number })?.status;
      setApiError(
        status === 404
          ? 'Product not found (404). Please check the product code.'
          : `An error occurred (${status ?? 'unknown'}).`,
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <>
      <div className='tw-fixed tw-bottom-10 tw-right-20'>
        <IconButton icon='Plus' label='New' onClick={onOpenModal} />
      </div>
      <Modal
        onDismiss={onCloseModal}
        isOpen={visible}
        headerSlot={'New Nickname Item'}
      >
        <div className='tw-flex tw-flex-col tw-justify-center'>
          <div className='tw-mb-3'>
            <TextField
              type='text'
              value={productCode}
              onChange={(event) => {
                const { target } = event;
                const val = (target as HTMLInputElement).value;
                setStErrMessage('');
                setProductCode(val);
              }}
              id='nickname-new-productCode'
              hasErrors={stErrMessage != ''}
              errorMessage={stErrMessage}
              placeholder='Product Code'
              label=''
              subtitle=''
            />
          </div>
          <div className='tw-mb-10'>
            <TextField
              type='text'
              value={nickName}
              onChange={(event) => {
                const { target } = event;
                const val = (target as HTMLInputElement).value;
                setNicknameErrMessage('');
                setNickName(val);
              }}
              id='nickname-new-nickname'
              hasErrors={nickNameErrMessage != ''}
              errorMessage={nickNameErrMessage}
              placeholder='Nickname'
              label=''
              subtitle='Comma-separated for multiple'
            />
          </div>
          {apiError && (
            <p className='tw-text-red-500 tw-text-sm tw-mb-4 tw-rounded tw-bg-red-50 tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-red-200'>
              {apiError}
            </p>
          )}
          <ButtonGroup>
            <Button
              onClick={onSubmitBtnClick}
              size='small'
              variant='secondary'
              className='eds-background--green-60 eds-color--white eds-border--green-60'
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting…' : 'Submit'}
            </Button>
            <Button onClick={onCloseModal} size='small' variant='secondary'>
              Cancel
            </Button>
          </ButtonGroup>
        </div>
      </Modal>
    </>
  );
}
